module.exports = __webpack_public_path__ + "assets/img/finastilsynet.2cee28c4.png";